import styled from "styled-components";

export const StyledParagraph = styled.p`
	color: #ff6666;
	border: 1px solid #ff6666;
	padding: 0.5em 1em;
`;
